/* eslint-disable */

//tslint:disable

import { IModel, IModelResponse } from '@cian/http-api/shared/model';
import { ICreateSubscriptionResponseSchema } from '../../entities/schemas/CreateSubscriptionResponseSchema';

export type TCreateSubscriptionModel = IModel<ICreateSubscriptionRequest, TCreateSubscriptionResponse>;

export interface ICreateSubscriptionRequest {
  /** Email для подписки **/
  email: string;
  /** json query **/
  jsonQuery: any;
  /** Частота рассылки **/
  notificationFrequency?: ENotificationFrequency | null;
  /** Тип СП, например по адресу дома building_address **/
  savedSearchType?: ESavedSearchType | null;
  /** Где создана подписка **/
  source?: ESource | null;
  /** Подписка на новости **/
  subscribeNews?: boolean | null;
  /** Название закладки **/
  title?: string | null;
}

export type TCreateSubscriptionResponse = ICreateSubscriptionResponse200 | ICreateSubscriptionResponse400;

export interface ICreateSubscriptionResponse200 extends IModelResponse<ICreateSubscriptionResponse> {
  statusCode: 200;
}

export interface ICreateSubscriptionResponse400 extends IModelResponse<ICreateSubscriptionResponseError> {
  statusCode: 400;
}

export interface ICreateSubscriptionResponse {
  data: ICreateSubscriptionResponseSchema;
  status: EStatus;
}

export interface ICreateSubscriptionResponseError {
  errors: any[];
  message: string;
}

export type TResponses = ICreateSubscriptionResponse | ICreateSubscriptionResponseError;

export enum EStatus {
  /** undefined **/
  Ok = 'ok',
}

export enum ENotificationFrequency {
  /** Оперативно (по мере поступления, с 9-21) **/
  Asap = 'asap',
  /** 1 раз в сутки **/
  EveryDay = 'everyDay',
  /** 1 раз в час (9-21) **/
  EveryHour = 'everyHour',
  /** 1 раз в неделю **/
  EveryWeek = 'everyWeek',
  /** Не активирована **/
  NotActivated = 'notActivated',
  /** Удалено **/
  Removed = 'removed',
}

export enum ESavedSearchType {
  /** По адресу дома **/
  BuildingAddress = 'buildingAddress',
  /** Обычный **/
  Common = 'common',
  /** Без дома **/
  NonBuildingAddress = 'nonBuildingAddress',
}

export enum ESource {
  /** Подписка создата на выдаче **/
  Listing = 'listing',
  /** Подписка создата на карте **/
  Map = 'map',
}

export interface IMappers<TResponse200, TResponse400> {
  200(response: ICreateSubscriptionResponse): TResponse200;
  400(response: ICreateSubscriptionResponseError): TResponse400;
}
